import { styled } from '@mui/system';
import Card, { CardProps } from '@mui/material/Card';

export const RoundCardComponent = styled(Card)<CardProps>(() => ({
  borderRadius: '20px',
}));
